import { render, staticRenderFns } from "./Wselect.vue?vue&type=template&id=a47e9964&scoped=true&"
import script from "./Wselect.vue?vue&type=script&lang=js&"
export * from "./Wselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47e9964",
  null
  
)

export default component.exports